import React from 'react';
import { formatSEK } from './formatUtils';

/**
 * SimpleChart — Lightweight bar chart using pure CSS.
 * No recharts dependency needed — CSS bars are simpler and lighter for our use case.
 */
export default function SimpleChart({ artifact }) {
  const { title, data = [], series = ['Värde'], yLabel } = artifact;
  if (!data.length) return null;

  const hasTwoSeries = data.some(d => d.value2 != null);
  const maxValue = Math.max(
    ...data.map(d => Math.max(d.value || 0, d.value2 || 0))
  );

  return (
    <div className="finn-artifact finn-chart">
      {title && (
        <div className="finn-artifact-header">
          <span className="finn-artifact-title">{title}</span>
        </div>
      )}

      {/* Legend */}
      {hasTwoSeries && (
        <div className="finn-chart-legend">
          <span className="finn-chart-legend-item">
            <span className="finn-chart-dot finn-chart-dot-primary" />
            {series[0] || 'Serie 1'}
          </span>
          <span className="finn-chart-legend-item">
            <span className="finn-chart-dot finn-chart-dot-secondary" />
            {series[1] || 'Serie 2'}
          </span>
        </div>
      )}

      {/* Chart body */}
      <div className="finn-chart-body">
        {yLabel && <div className="finn-chart-ylabel">{yLabel}</div>}
        <div className="finn-chart-bars">
          {data.map((point, i) => {
            const pct1 = maxValue > 0 ? (point.value / maxValue) * 100 : 0;
            const pct2 = maxValue > 0 && point.value2 ? (point.value2 / maxValue) * 100 : 0;

            return (
              <div key={i} className="finn-chart-column">
                <div className="finn-chart-bar-group">
                  <div
                    className="finn-chart-bar finn-chart-bar-primary"
                    style={{ height: `${pct1}%` }}
                    title={`${series[0] || 'Värde'}: ${formatSEK(point.value)}`}
                  />
                  {hasTwoSeries && (
                    <div
                      className="finn-chart-bar finn-chart-bar-secondary"
                      style={{ height: `${pct2}%` }}
                      title={`${series[1] || 'Serie 2'}: ${formatSEK(point.value2)}`}
                    />
                  )}
                </div>
                <div className="finn-chart-label">{point.label}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
